export const TABS = ["home", "explore", "library", "profile"] as const;
export type Tab = (typeof TABS)[number];

export const isRealTab = (tab: string | undefined): tab is Tab =>
  TABS.includes(tab as Tab);

/**
 * Profile is mounted with the tab navigator so its nested stack and loading
 * chrome are ready before the first tap. Other tabs can keep their lazy
 * first-mount behaviour.
 */
export const shouldLazyLoadTab = (tab: Tab) => tab !== "profile";
